import {
  AHB_MESSAGE_TYPE,
  AHB_PROCEDURE_ID,
  AHB_SUBPROCEDURE,
  AHB_VERSION,
  AHB_WITHDRAW_REASON,
} from "core/consts";
import { format, utcToZonedTime } from "date-fns-tz";
import { AHBWithdrawPartialPayload } from "onprem/hooks";
import { v4 as uuidv4 } from "uuid";
import { nullsToUndefined } from "./shared";

const timeZone = "Europe/Berlin";

function formatDateYYYYMMDD(
  date: Date | number | null | undefined,
): string | undefined {
  if (!date) {
    return undefined;
  }

  let dateObject: Date;

  if (typeof date === "number") {
    dateObject = new Date(date * 1000);
  } else {
    dateObject = date;
  }

  const zonedDate = utcToZonedTime(dateObject, timeZone);

  return format(zonedDate, "yyyyMMdd");
}

export function mapToRehabWithdrawal({
  isProd,
  unsanitizedForm,
}: {
  isProd: boolean;
  unsanitizedForm: AHBWithdrawPartialPayload;
}) {
  const form = nullsToUndefined(unsanitizedForm);
  const now = new Date();
  const zonedDate = utcToZonedTime(now, timeZone);
  const erstellungsdatum = formatDateYYYYMMDD(now);
  const erstellungszeit = format(zonedDate, "HHmmss");
  const dateiID = uuidv4();

  if (!erstellungsdatum) {
    throw new Error("Missing gdb:Erstellungsdatum");
  }

  return {
    Nutzdaten: {
      "@xmlns": "http://www.gkv-datenaustausch.de/XMLSchema/GKH_DAT/1.1",
      "@xmlns:gdb": "http://www.gkv-datenaustausch.de/XMLSchema/GKH_basis/1.1",
      "@xmlns:aar":
        "http://www.gkv-datenaustausch.de/XMLSchema/GKH_AAR_DAT/1.1",
      "@xmlns:arh":
        "http://www.gkv-datenaustausch.de/XMLSchema/GKH_AAR_ARH/1.1",
      "@xmlns:feh": "http://www.gkv-datenaustausch.de/XMLSchema/GKH_FEH/1.1",
      "@xmlns:sto": "http://www.gkv-datenaustausch.de/XMLSchema/GKH_STO/1.1",
      Header: {
        "gdb:Absender": {
          "gdb:Krankenhaus": {
            "gdb:Institutionskennzeichen": form.hospital_ik_number
              ? String(form.hospital_ik_number)
              : "",
          },
        },
        "gdb:Empfaenger": {
          "gdb:Krankenkasse": {
            "gdb:Institutionskennzeichen": form.insurance_ik_number
              ? String(form.insurance_ik_number)
              : "",
          },
        },
        "gdb:Erstellungsdatum": erstellungsdatum,
        "gdb:Erstellungszeit": erstellungszeit,
        "gdb:Datei_ID": dateiID,
        "gdb:Verfahrenskennung": isProd
          ? AHB_PROCEDURE_ID.PRODUCTION
          : AHB_PROCEDURE_ID.TEST,
        "gdb:Unterverfahren": AHB_SUBPROCEDURE,
        "gdb:Nachrichtentyp": AHB_MESSAGE_TYPE.WITHDRAWAL,
        "gdb:Logische_Version": AHB_VERSION.V1_1_0,
        "gdb:Dateinummer": form.documentNumber,
      },
      Body: {
        Stornonachricht: {
          "sto:Datei_ID": form.request_message_id,
          "sto:Begruendung": {
            "sto:Grund": form.withdraw_reason,
            ...(form.withdraw_reason === AHB_WITHDRAW_REASON.OTHER &&
            form.withdraw_reason_other
              ? { "sto:Erlaeuterung": form.withdraw_reason_other }
              : {}),
          },
        },
      },
    },
  };
}
